import { escape, unescape } from 'html-escaper'

export default (context, inject) => {
  // this.$escaper()
  const escapeText = (text) => {
    return text ? escape(text) : ''
  }

  const unescapeText = (text) => {
    return text ? unescape(text) : ''
  }
  // Inject $hello(msg) in Vue, context and store.
  inject('escape', escapeText)
  inject('unescape', unescapeText)
  // For Nuxt <= 2.12, also add 👇
  context.$escape = escapeText
  context.$unescape = unescapeText
}
